module.exports = __webpack_public_path__ + "img/fan-casing_106x106.39cf639f.png";